import React from 'react';
import styled, { css } from 'styled-components';
import { fontWeight, fontSize, fontFamily } from '@whitelabel/helpers/style/type';
import { gray } from '@whitelabel/helpers/style/colors';
import { mediaBreakpointUp } from '@whitelabel/helpers/style/grid';
import { multiply } from '@whitelabel/helpers/style/units';
import { getThemeProp } from '@whitelabel/helpers/style/get';
import { Button } from '@whitelabel/component-library';
import PartnerHeading from '../../PartnerHeading';
import PolicyHeading from '../../PolicyHeading';
import PolicyTabs from '../../PolicyTabs';
import { StyledPartner, StyledTitleBox } from '../../PartnerHeading/styledPartnerHeading';

// Disable eslint to keep the original logic: not pass no-unused-vars
// props down to child component.
// eslint-disable-next-line @typescript-eslint/no-unused-vars
export const StyledPartnerHeading = styled(({ singlePolicy, showDisclaimer, ...props }) => (
  <PartnerHeading {...props} />
))`
  ${({ singlePolicy }) =>
    singlePolicy
      ? css`
          padding-bottom: 1rem;
          border-bottom: ${getThemeProp('borderStyle')};

          ${mediaBreakpointUp('md')`
            padding-bottom: 2rem;
          `}

          ${StyledPartner} {
            grid-row: 1;
            margin-bottom: 1rem;
            padding-bottom: 1rem;
            border-bottom: ${getThemeProp('borderStyle')};

            ${mediaBreakpointUp('md')`
              grid-row: ${({ showDisclaimer }: any) => (showDisclaimer ? `2 / span 2` : 2)};
              margin-bottom: 0;
              padding-bottom: 0;
              border-bottom: 0;
            `}
          }
        `
      : css`
          ${StyledTitleBox} {
            padding-bottom: 1rem;
            border-bottom: ${getThemeProp('borderStyle')};
          }

          ${StyledPartner} {
            grid-row: 1;
            margin-bottom: 1rem;
            padding-bottom: 1rem;
            border-bottom: ${getThemeProp('borderStyle')};

            ${mediaBreakpointUp('md')`
              margin-bottom: 0;
            `}

            ${mediaBreakpointUp('lg')`
              padding-bottom: 2rem;
            `}
          }
        `}
`;

// Disable eslint to keep the original logic: not pass no-unused-vars
// props down to child component.
// eslint-disable-next-line @typescript-eslint/no-unused-vars
export const StyledPolicies = styled(({ singlePolicy, ...props }) => <div {...props} />)`
  grid-row: 3;
  grid-column: 1 / 3;
`;

export const StyledPolicyHeading = styled(StyledPolicies).attrs(() => ({ as: PolicyHeading }))`
  flex-direction: column;
  grid-column: 1 / 2;
  margin-bottom: 0;

  && {
    font-size: ${multiply(fontSize('base'), 1.5)};

    ${mediaBreakpointUp('md')`
      flex-direction: row;
      grid-row: 2;
      font-size: ${multiply(fontSize('base'), 2.5)};
    `}

    ${mediaBreakpointUp('lg')`
      font-size: ${multiply(fontSize('base'), 3)};
    `}
  }
`;

export const StyledPolicyTabs = styled(StyledPolicies).attrs(() => ({ as: PolicyTabs }))``;

export const StyledDisclaimer = styled.div`
  grid-column: 1 / 3;
  margin-bottom: 0.5rem;
  color: ${gray(600)};
  font-weight: ${fontWeight('base')};
  font-size: ${fontSize('md')};
  font-family: ${fontFamily('serif')};
  text-transform: none;

  ${mediaBreakpointUp('md')`
    grid-column: 1 / 2;
    margin-bottom: 0;
  `}

  p {
    margin-bottom: 0;
    font-size: ${fontSize('sm')};
    text-align: center;

    ${mediaBreakpointUp('md')`
      font-size: ${fontSize('md')};
      text-align: start;
    `}
  }
`;

export const StyledButton = styled(Button)`
  margin-top: 1rem;
  justify-content: flex-start;
  grid-row-start: 4;
`;

export const StyledWrapper = styled.div`
  @media print {
    :not(:first-child) {
      page-break-before: always;
    }
  }
`;
